import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './PageLayout.css'
import Header from '$src/common/PageLayout/Header'
import AlertBanner from '$src/common/PageLayout/AlertBanner'

@observer
export default class PageLayout extends Component<{css?: any}, {}> {
  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)

    return (
      <div {...classes('container')}>
        <AlertBanner />
        <Header />
        <div {...classes('body')}>{props.children}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/PageLayout/PageLayout.tsx